function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import AbstractInput from '../AbstractInput';
import { classNamesFor } from '../utils/classNames';
import filterA11YProps from '../utils/filterA11YProps';
var cx = classNamesFor(Button);
/**
 * The FilePicker component allows a user to select a file from their local file system
 *
 * - [MDN docs on input type file](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file)
 *
 * ## Related Components
 * - [FileDropArea](../FileDropArea/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <FilePicker
 *   ctaType="secondary"
 *   variant="outline"
 *   onChange={e => e.target.files}
 *   accept="image/*"
 * >
 *   Select a file
 * </FilePicker>
 * ```
 *
 * ## Props
 */

var FilePicker = /*#__PURE__*/function (_AbstractInput) {
  _inherits(FilePicker, _AbstractInput);

  var _super = _createSuper(FilePicker);

  function FilePicker() {
    _classCallCheck(this, FilePicker);

    return _super.apply(this, arguments);
  }

  _createClass(FilePicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          id = _this$props.id,
          className = _this$props.className,
          ariaLabel = _this$props.ariaLabel,
          disabled = _this$props.disabled,
          variant = _this$props.variant,
          ctaType = _this$props.ctaType,
          background = _this$props.background,
          iconOnly = _this$props.iconOnly,
          accept = _this$props.accept,
          multiple = _this$props.multiple,
          onChange = _this$props.onChange,
          children = _this$props.children,
          a11yProps = _objectWithoutProperties(_this$props, ["qa", "id", "className", "ariaLabel", "disabled", "variant", "ctaType", "background", "iconOnly", "accept", "multiple", "onChange", "children"]);

      var isFocused = this.state.isFocused;

      var _FilePicker$getClassN = FilePicker.getClassName({
        className: className,
        variant: variant,
        ctaType: ctaType,
        background: background,
        iconOnly: iconOnly,
        disabled: disabled,
        isFocused: isFocused
      }),
          root = _FilePicker$getClassN.root,
          input = _FilePicker$getClassN.input;

      var controlId = id || this.id;
      return /*#__PURE__*/React.createElement("label", {
        "data-qa": qa,
        htmlFor: controlId,
        className: root
      }, /*#__PURE__*/React.createElement("input", _extends({}, filterA11YProps(a11yProps), {
        "data-qa": "".concat(qa, "#input"),
        className: input,
        type: "file",
        "aria-label": ariaLabel,
        accept: accept,
        multiple: multiple,
        id: controlId,
        disabled: disabled,
        onChange: onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      })), children);
    }
  }]);

  return FilePicker;
}(AbstractInput);

FilePicker.getClassName = function (_ref) {
  var className = _ref.className,
      variant = _ref.variant,
      ctaType = _ref.ctaType,
      background = _ref.background,
      iconOnly = _ref.iconOnly,
      isFocused = _ref.isFocused,
      disabled = _ref.disabled;
  return {
    root: cx('psw-file-picker', Button.getClassName({
      className: className,
      variant: variant,
      ctaType: ctaType,
      background: background,
      iconOnly: iconOnly,
      isFocused: isFocused,
      disabled: disabled
    }).root),
    input: cx('psw-visually-hide')
  };
};

FilePicker.defaultProps = {
  id: '',
  className: '',
  ariaLabel: '',
  iconOnly: false,
  variant: 'solid',
  ctaType: '',
  background: 'light',
  disabled: false,
  accept: '',
  multiple: false,
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  children: null
};
FilePicker.propTypes = {
  /**
   * Id required for associating the label, will auto generate id if missing to
   * link the label properly. Perfer setting the id explicitly
   */
  id: PropTypes.string,

  /**
   * Label text describing the control for screen readers
   */
  ariaLabel: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Button only contains an icon like in the case of action buttons
   */
  iconOnly: PropTypes.bool,

  /**
   * Presentational variant to apply
   */
  variant: PropTypes.oneOf(['solid', 'outline', 'content']),

  /**
   * The type of button in design language
   */
  ctaType: PropTypes.oneOf(['', 'primary', 'secondary', 'alt-secondary', 'purchase']),

  /**
   * Whether the button is on a dark or light background. Required for `outline` variants
   */
  background: PropTypes.oneOf(['dark', 'light']),

  /**
   * Whether or not the button is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Comma separated string of file extensions or mime types to accept on drop
   */
  accept: PropTypes.string,

  /**
   * Whether or not the control allows multiple files to be selected
   */
  multiple: PropTypes.bool,

  /**
   * event callback to call when picked file has changed
   */
  onChange: PropTypes.func,

  /**
   * event callback to call when input received focus
   */
  onFocus: PropTypes.func,

  /**
   * event callback to call when input loses focus
   */
  onBlur: PropTypes.func,

  /**
   * For label text or other UI
   */
  children: PropTypes.node
};
export default FilePicker;